import styled from 'styled-components'
import { UnderlineGraphic } from '@/components/Icons.styles'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 400px;

  @media (max-width: 1000px) {
    flex-direction: column;
    height: 380px;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  @media (max-width: 1000px) {
    height: 100%;

    > div {
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      position: relative;
      gap: 20px;
      height: 100%;
    }
  }
`
export const ContentLeft = styled.div`
  width: 50%;

  > div {
    font-size: 40px;
  }

  p {
    font-size: 54px;
  }

  @media (max-width: 1000px) {
    width: 97%;
    height: 50%;
    text-align: center;

    ${UnderlineGraphic} {
      bottom: -17px;
      left: 50%;
      transform: translateX(-50%) rotate(2deg);
    }

    p {
      font-size: 34px;
    }

    > div {
      font-size: 24px;
    }
  }
`
export const ContentRight = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
  gap: 10px;

  button {
    transition: 0.2s ease;
    font-size: 16px;
  }

  @media (max-width: 1000px) {
    width: 84%;
    min-height: unset;
    height: 50%;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    button {
      font-size: 13px;
      padding: 8px 16px;
    }
  }
`
export const Arrows = styled.div`
  margin-top: 50px;
  display: flex;
  gap: 20px;

  svg {
    rect {
      stroke: var(--brand-secondary);
    }
  }

  @media (max-width: 1000px) {
    margin: 0;
    position: absolute;
    bottom: 17px;
    left: 25px;
    width: calc(100% - 50px);
    justify-content: space-between;
    box-sizing: border-box;
    pointer-events: none;

    svg {
      path {
      }
      rect {
        stroke-width: 0px;
        fill: white;
      }
    }
  }
`
export const ArrowLeft = styled.div`
  cursor: pointer;

  svg {
    width: 42px;
  }

  &:hover {
    opacity: 0.7;
  }

  &:focus,
  &:active {
    opacity: 1;
    outline: none;
  }

  @media (max-width: 1000px) {
    pointer-events: all;

    svg {
      width: 32px;
    }
  }
`
export const ArrowRight = styled(ArrowLeft)``
export const BackgroundLeft = styled.div`
  flex-shrink: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 35%;
  background: ${({ theme }) => theme?.banner?.colour || '#fab416'};
  z-index: 2;

  svg {
    position: absolute;
    height: 100%;
    right: 0;
    top: 0;
    transform: translateX(26%);

    &.desktop {
      display: block;
    }
    &.mobile {
      display: none;
      left: 0;
      height: auto;
      width: 100%;
      transform: none;
      top: -20px;
    }
  }

  @media (max-width: 1000px) {
    width: 100%;
    height: 150px;
    background: var(--brand-primary);

    svg.desktop {
      display: none;
    }
  }

  @media (max-width: 500px) {
    background: transparent;

    svg.mobile {
      display: block;
    }
  }
`
export const Background = styled.div<{ image: string }>`
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  transition: 0.45s opacity ease-in-out;
`
export const BackgroundRight = styled.div<{ activeBanner: number }>`
  flex-shrink: 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 65%;
  z-index: 1;
  pointer-events: none;

  ${Background}:nth-child(${({ activeBanner }) => activeBanner}) {
    opacity: 1;
  }

  @media (max-width: 1000px) {
    width: 100%;
    height: 370px;
    bottom: 0;
    top: auto;
  }
`

export const Subtitle = styled.h1`
  font-size: 20px;
  line-height: 1.5;
  font-weight: var(--font-medium);
  text-wrap: balance;
  max-width: 350px;

  @media (max-width: 1000px) {
    font-size: 14px;
    max-width: unset;
  }
`

export const TrustFactorsWrap = styled.div`
  position: absolute;
  bottom: 0;
  transform: translateY(70%);
  z-index: 3;
  width: 100%;

  > div > div {
    background: white;
    padding: 30px 0 0 0;
    border-radius: 20px 20px 0 0;
    box-sizing: border-box;
  }

  @media (max-width: 1000px) {
    width: calc(100% - 50px);
    box-sizing: border-box;
    position: static;
    transform: none;
    margin-bottom: -45px;

    > div > div {
      padding: 15px 20px 0 20px;
    }
  }
`

export const HeadingRight = styled.div`
  padding: 8px 16px;
  color: white;
  border-radius: 6px;
  font-size: 18px;
  font-weight: var(--font-bold);
  text-wrap: nowrap;
  background-color: ${({ theme }) => theme?.colourPalette?.primaryColour || 'var(--sale)'};

  @media (max-width: 1000px) {
    padding: 8px 10px;
    margin-top: auto;
    font-size: 12px;
    gap: 10px;
  }
`

export const IconWrapper = styled.div`
  svg {
    width: 128px;
    height: 128px;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
  }

  @media (max-width: 600px) {
    svg {
      width: 60px;
      height: 60px;
      top: auto;
      bottom: 60px;
      right: 20px;
      z-index: 1;
    }
  }
`
